export default {"src":"/_next/static/media/2_Arrow_Sm.f7a2508e.svg","height":248,"width":142};